import { render, staticRenderFns } from "./purchaseData.vue?vue&type=template&id=507d123c&scoped=true"
import script from "./purchaseData.vue?vue&type=script&lang=js"
export * from "./purchaseData.vue?vue&type=script&lang=js"
import style0 from "./purchaseData.vue?vue&type=style&index=0&id=507d123c&prod&scoped=true&lang=css"
import style1 from "./purchaseData.vue?vue&type=style&index=1&id=507d123c&prod&scoped=true&lang=css"
import style2 from "./purchaseData.vue?vue&type=style&index=2&id=507d123c&prod&scoped=true&lang=css"
import style3 from "./purchaseData.vue?vue&type=style&index=3&id=507d123c&prod&lang=less&scoped=true"
import style4 from "./purchaseData.vue?vue&type=style&index=4&id=507d123c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d123c",
  null
  
)

export default component.exports